import { MapProvider } from "../../types/enums";
import { GoogleProvider } from "./google/google-provider";
import { HereProvider } from "./here/here-provider";
import { IMapProvider } from "./map-provider.interface";
import { NoneProvider } from "./none/none-provider";

export class MapProviderFactory {
    static getMapProvider(mapProviderId: MapProvider, apiKey?: string): IMapProvider {
        switch (mapProviderId) {
            case MapProvider.GOOGLE:
                if (!apiKey)
                    return new NoneProvider();
                return new GoogleProvider({ apiKey: apiKey });

            case MapProvider.HERE:
                if (!apiKey)
                    return new NoneProvider();
                return new HereProvider({ apiKey: apiKey });

            default:
                return new NoneProvider();
        }
    }
}